import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemRolesActorsRoute: InvariantJiraRoute = {
	name: 'global-settings-system-roles-actors',
	path: '/secure/project/ViewDefaultProjectRoleActors([!%]?[\\w]*).jspa',
};
